import BAApi from './_baApi';

class BABankTransferAPI extends BAApi {
  constructor() {
    super();
  }
  controllerName = 'BABankTransfers';
}

export default new BABankTransferAPI();
